// THE definition of a "session" that customers are shown, in ONE place.
//
// Used by the footer's Sessions tooltip and the segment drawer's Sessions tooltip, which were two separately written texts
// that said nearly the same thing. A customer comparing Skydive with another tool will look for exactly this sentence, so it must
// not drift between surfaces.
//
// It is true because the backend counts only sessions that have ended: getSegmentSummary sets `session_end_time: { $ne: null }`
// (skydive_backend, metrics.repo.ts, "Departed sessions only"), and a visitor still on the site is shown under the dashboard's
// "Total Visitors onsite" instead. How "ended" is decided (the disconnect grace and the idle sweep) is NOT stated here; if that is
// ever explained to customers, it belongs in a Help article, not in a tooltip.
export const SESSION_DEFINITION = "A session is a visit that has ended; someone still on the site isn't counted yet.";
